import {
  Box,
  Flex,
  TextV2 as Text,
  Colors,
  Tag,
  Loader,
  Tooltip,
} from '@pinchenterprisesnpm/friday-ui'
import { connect, FormikProps } from 'formik'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/pro-solid-svg-icons'
import { faPen } from '@fortawesome/pro-light-svg-icons'
import { useHistory, useLocation } from 'react-router'
import { STEP_INDEX } from '@src/features/shift-post-v2/state/shift-post-v2.types'
import { IRoster } from 'models/Roster'
import { selectSelectedShift } from '@src/data/SelectedShift/selectors'
import { useSelector } from 'react-redux'
import ROUTES from '@src/routing/adminRoutes'
import {
  selectBusinessRosters,
  selectBusinessRostersIsFetching,
} from '@src/data/BusinessRosters/selectors'
import { SectionContainer } from '../new-edit-modal.style'
import { INewEditModalFormValues } from '../new-edit-modal.form'
import { navigateToEditShift } from '../navigation.utils'

interface IInvitationSummarySectionProps {
  formik?: FormikProps<INewEditModalFormValues>
}

export const InvitationSummarySection = connect<IInvitationSummarySectionProps>(({ formik }) => {
  const {
    values: { rosters },
  } = formik
  const history = useHistory()
  const rostersData = rosters?.data || []
  const shift = useSelector(selectSelectedShift)
  const location = useLocation()
  const isBusinessShifts = location.pathname.includes(ROUTES.BUSINESSES_LIST)
  const businessRosters = useSelector(selectBusinessRosters)
  const businessRostersIsFetching = useSelector(selectBusinessRostersIsFetching)

  const handleNavigateToEditShift = () => {
    navigateToEditShift(
      formik.values,
      shift,
      history,
      STEP_INDEX.INVITE_UPSHIFTERS,
      isBusinessShifts
    )
  }

  return (
    <SectionContainer>
      <Flex mb='sm' justifyContent='space-between'>
        <Text variant='h6'>
          Invitation summary <Tag type='plum'>NEW</Tag>
        </Text>
        <FontAwesomeIcon
          icon={faPen}
          size='lg'
          style={{
            marginLeft: '8px',
            cursor: 'pointer',
            color: Colors.primary_500,
          }}
          onClick={handleNavigateToEditShift}
        />
      </Flex>
      {businessRostersIsFetching && (
        <Flex justifyContent='center' alignItems='center' height='100%'>
          <Loader />
        </Flex>
      )}
      {!businessRostersIsFetching && (
        <Box style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {rostersData.map((roster: IRoster) => {
            const isUnavailable =
              businessRosters.find((businessRoster) => businessRoster.id === roster.id)
                ?.is_available_for_invite === false

            return (
              <Flex key={roster.id} mb='xs' alignItems='center'>
                <FontAwesomeIcon
                  icon={faCheck}
                  color='#43b94a'
                  size='lg'
                  style={{ marginRight: '8px' }}
                />
                <Box>
                  <Text>{roster.name} </Text>
                </Box>
                {isUnavailable && (
                  <Tooltip text='None of the Upshifters in this roster are eligible for an invite.'>
                    <span>
                      <Tag size='small' type='danger' mx='xs'>
                        Unavailable
                      </Tag>
                    </span>
                  </Tooltip>
                )}
              </Flex>
            )
          })}
        </Box>
      )}
    </SectionContainer>
  )
})
